<bw-action-article [brightsideWebFb]="{ event_name: 'get_the_app_shown' }">
  <ui-nav-exit-back header-actions [trackingDetail]="{ event_name: 'get_the_app_dismissed' }"></ui-nav-exit-back>

  <typography title-medium header-title>{{ 'GET_APP_TITLE' | translate }}</typography>
  <div content-section>
  <bw-paragraph>{{ 'GET_APP_DESC' | translate }}</bw-paragraph>
  <bw-phone-form #pfc label="{{ 'MOBILE_PHONE_NUMBER' | translate }}" fcName="mobile" [autoFocus]="true" (keyup.enter)="getTheApp()"
                 [brightsideWebFb]="{ event_name: 'get_the_app_tapped', action: 'click' }"
  ></bw-phone-form>
    <bw-caption>{{ 'GET_APP_RATES' | translate }}</bw-caption>
  </div>
  <button bw-button footer-actions
          [disabled]="!(phoneFormIsValid$ | async)"
          (click)="getTheApp()"
          [processing]="processing"
          [brightsideWebFb]="{ event_name: 'get_the_app_tapped', action: 'click' }"
  >{{ 'BUTTON_CONTINUE' | translate }}</button>
</bw-action-article>
